// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-input[data-v-6c97a05b]{border:.5px dashed green;max-width:100%;font-weight:700;font-size:14px;text-align:center}", ""]);
// Exports
module.exports = exports;
